module.exports = __webpack_public_path__ + "static/img/birthday-cake.19d63258.png";